import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Button } from "../components/ui/button";
import { Mail, Phone, Calendar, MessageCircle, ArrowRight } from "lucide-react";

const Contact = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
        {/* Header */}
        <div className="text-center mb-12 sm:mb-16">
          <h1 className="text-3xl sm:text-4xl lg:text-6xl font-bold text-gray-800 mb-6">
            Hablemos de tu{" "}
            <span className="bg-gradient-to-r from-purple-600 to-blue-600 bg-clip-text text-transparent">
              proyecto
            </span>
          </h1>
          <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto px-4">
            Estamos aquí para ayudarte a transformar tu negocio con IA. 
            Elige la forma que prefieras para contactarnos.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12">
          {/* Contact Information */}
          <div className="space-y-6 sm:space-y-8">
            <div>
              <h2 className="text-xl sm:text-2xl font-bold text-gray-800 mb-6 sm:mb-8">Información de contacto</h2>
              
              {/* Email */}
              <div className="flex items-start space-x-4 mb-6 sm:mb-8">
                <div className="flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 bg-purple-100 rounded-xl flex items-center justify-center">
                  <Mail className="h-5 w-5 sm:h-6 sm:w-6 text-purple-600" />
                </div>
                <div>
                  <h3 className="text-base sm:text-lg font-semibold text-gray-800 mb-2">Email</h3>
                  <p className="text-sm sm:text-base text-gray-600 mb-2">
                    Escríbenos para consultas generales o información detallada sobre nuestros servicios.
                  </p>
                  <a 
                    href="mailto:info@innova2market.es"
                    className="text-purple-600 hover:text-purple-700 font-medium text-sm sm:text-base"
                  >
                    info@innova2market.es
                  </a>
                </div>
              </div>

              {/* Phone */}
              <div className="flex items-start space-x-4 mb-6 sm:mb-8">
                <div className="flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 bg-blue-100 rounded-xl flex items-center justify-center">
                  <Phone className="h-5 w-5 sm:h-6 sm:w-6 text-blue-600" />
                </div>
                <div>
                  <h3 className="text-base sm:text-lg font-semibold text-gray-800 mb-2">Teléfono</h3>
                  <p className="text-sm sm:text-base text-gray-600 mb-2">
                    Llámanos para una conversación directa sobre tu proyecto.
                  </p>
                  <a 
                    href="tel:+34604971608"
                    className="text-blue-600 hover:text-blue-700 font-medium text-sm sm:text-base"
                  >
                    +34 604 97 16 08
                  </a>
                </div>
              </div>

              {/* Cal.com */}
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 bg-green-100 rounded-xl flex items-center justify-center">
                  <Calendar className="h-5 w-5 sm:h-6 sm:w-6 text-green-600" />
                </div>
                <div>
                  <h3 className="text-base sm:text-lg font-semibold text-gray-800 mb-2">Consulta gratuita</h3>
                  <p className="text-sm sm:text-base text-gray-600 mb-4">
                    Agenda una reunión de 30 minutos para discutir tu proyecto y cómo podemos ayudarte.
                  </p>
                  <Button 
                    onClick={() => window.open('https://cal.com/peter-gal/30min?overlayCalendar=true', '_blank')}
                    className="bg-green-600 hover:bg-green-700 text-white text-sm sm:text-base"
                  >
                    <Calendar className="mr-2 h-4 w-4" />
                    Agendar consulta
                    <ArrowRight className="ml-2 h-4 w-4" />
                  </Button>
                </div>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className="bg-gradient-to-br from-purple-50 to-blue-50 rounded-2xl sm:rounded-3xl p-6 sm:p-8 lg:p-12">
            <div className="text-center">
              <div className="w-12 h-12 sm:w-16 sm:h-16 bg-gradient-to-br from-purple-500 to-blue-500 rounded-2xl flex items-center justify-center mx-auto mb-4 sm:mb-6">
                <MessageCircle className="h-6 w-6 sm:h-8 sm:w-8 text-white" />
              </div>
              
              <h3 className="text-xl sm:text-2xl font-bold text-gray-800 mb-4">
                ¿Listo para empezar?
              </h3>
              
              <p className="text-sm sm:text-base text-gray-600 mb-6 sm:mb-8 leading-relaxed">
                En nuestra consulta gratuita analizaremos tu negocio, identificaremos 
                oportunidades de automatización y te mostraremos cómo la IA puede 
                transformar tu empresa.
              </p>

              <div className="space-y-3 sm:space-y-4">
                <Button 
                  size="lg"
                  onClick={() => window.open('https://cal.com/peter-gal/30min?overlayCalendar=true', '_blank')}
                  className="w-full bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-700 hover:to-blue-700 text-white px-6 sm:px-8 py-3 sm:py-4 font-semibold text-sm sm:text-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
                >
                  <Calendar className="mr-2 h-4 w-4 sm:h-5 sm:w-5" />
                  Reservar consulta gratuita
                  <ArrowRight className="ml-2 h-4 w-4 sm:h-5 sm:w-5" />
                </Button>
                
                <Button 
                  variant="outline"
                  size="lg"
                  onClick={() => window.location.href = '/demo'}
                  className="w-full border-purple-200 text-purple-600 hover:bg-purple-50 px-6 sm:px-8 py-3 sm:py-4 font-semibold text-sm sm:text-lg"
                >
                  <MessageCircle className="mr-2 h-4 w-4 sm:h-5 sm:w-5" />
                  Probar demo
                </Button>
              </div>

              <div className="mt-6 sm:mt-8 pt-6 sm:pt-8 border-t border-gray-200">
                <p className="text-xs sm:text-sm text-gray-500">
                  <strong>Tiempo de respuesta:</strong> Menos de 24 horas<br/>
                  <strong>Disponibilidad:</strong> Lunes a Viernes, 9:00 - 18:00
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Additional Info */}
        <div className="mt-12 sm:mt-16 text-center">
          <div className="bg-white border border-gray-200 rounded-2xl p-6 sm:p-8 max-w-4xl mx-auto">
            <h3 className="text-lg sm:text-xl font-semibold text-gray-800 mb-4 sm:mb-6">
              ¿Por qué elegir Innova2Market?
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6 text-xs sm:text-sm text-gray-600">
              <div>
                <div className="w-6 h-6 sm:w-8 sm:h-8 bg-green-100 rounded-lg flex items-center justify-center mx-auto mb-2 sm:mb-3">
                  <span className="text-green-600 font-bold text-sm sm:text-base">✓</span>
                </div>
                <p><strong>Experiencia probada</strong><br/>Más de 50 proyectos exitosos</p>
              </div>
              <div>
                <div className="w-6 h-6 sm:w-8 sm:h-8 bg-blue-100 rounded-lg flex items-center justify-center mx-auto mb-2 sm:mb-3">
                  <span className="text-blue-600 font-bold text-sm sm:text-base">✓</span>
                </div>
                <p><strong>Soporte 24/7</strong><br/>Asistencia técnica continua</p>
              </div>
              <div>
                <div className="w-6 h-6 sm:w-8 sm:h-8 bg-purple-100 rounded-lg flex items-center justify-center mx-auto mb-2 sm:mb-3">
                  <span className="text-purple-600 font-bold text-sm sm:text-base">✓</span>
                </div>
                <p><strong>Resultados garantizados</strong><br/>ROI medible en 30 días</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default Contact;
